import React from "react";
import Toggle from "@streeteasy/design-system/legacy/Toggle";
import { func, string } from "prop-types";

import { Disclaimer } from "src/shared/components/Disclaimer";

import {
  RequestFormBreak,
  RequestFormSectionContainer,
  RequestFormSectionHeader,
  RequestFormToggleDiv
} from "../styled";

const tabItems = [
  {
    text: "In-person",
    value: "in_person"
  },
  {
    text: "Video Chat",
    value: "video_chat"
  }
];

const TourTypeSection = ({ onChange, tourType }) => (
  <RequestFormSectionContainer hasMargin>
    <RequestFormBreak />
    <RequestFormSectionHeader>
      TOUR TYPE
      <Disclaimer>(Optional)</Disclaimer>
    </RequestFormSectionHeader>
    <RequestFormToggleDiv>
      <Toggle
        defaultValue={tourType}
        onClick={e =>
          onChange(e.tabData.value, { target: { name: "tourType" } })
        }
        tabItems={tabItems}
      />
    </RequestFormToggleDiv>
  </RequestFormSectionContainer>
);

TourTypeSection.propTypes = {
  onChange: func.isRequired,
  tourType: string.isRequired
};

export default TourTypeSection;
